import { Component, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';

@Component({
    selector: 'savings-rate',
    templateUrl: './savings-rate.component.html',
    styleUrls: ['./savings-rate.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class SavingsRateComponent implements OnInit {
  options: FormControlOption[] = [
    {
      value: 'GREATER_THAN_102',
      label: 'Plus de 102€',
      suffix: { title: 'A' },
    },
    {
      value: 'EQUAL_102',
      label: 'Exactement 102€',
      suffix: { title: 'B' },
    },
    { value: 'UNKNOWN', label: 'Je ne sais pas ', suffix: { title: 'C' } },
  ];
  constructor() {}

  ngOnInit() {}
}
